module.exports = __webpack_public_path__ + "static/media/blush-multiplo-stick.5ecc382f.png";